<template>
  <v-card>
    <v-card-title>
      Group Menu
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details outlined
        dense></v-text-field>
    </v-card-title>

    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="cgm_sort_order"
      class="elevation-1 ma-3">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>List Data</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#0A7EA5" dark class="mb-2" v-bind="attrs" v-on="on" :disabled="!authorize_add"
                v-if="company_id == 1 && role == 'ADMIN'">
                + Create Group Menu
              </v-btn>
            </template>
            <v-card style="padding: 1rem 0.5rem;">
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text style="padding-bottom: 0;">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="editedItem.cgm_name" label="Group Menu Name" outlined dense
                        hide-details></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="editedItem.cgm_icon" label="Icon (เช่น mdi-view-dashboard)" outlined dense
                        hide-details></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model="editedItem.cgm_route"
                        label="Direct Route (ใส่เฉพาะกลุ่มที่ไม่มี Sub Menu เช่น /dashboard)" outlined dense
                        hide-details></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-text-field v-model.number="editedItem.cgm_sort_order" label="Sort Order" type="number" outlined
                        dense hide-details></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-switch v-model="editedItem.cgm_show_menu" inset dense label="Show in menu" color="#0A7EA5"
                        class="switch-small" hide-details></v-switch>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.cgm_icon="{ item }">
        <v-icon v-if="item.cgm_icon" small class="mr-1">{{
          item.cgm_icon
        }}</v-icon>
        {{ item.cgm_icon }}
      </template>
      <template v-slot:item.cgm_show_menu="{ item }">
        <div class="d-flex align-center">
          <v-switch v-model="item.cgm_show_menu" inset dense color="#0A7EA5" hide-details class="ma-0 pa-0 switch-small"
            :disabled="togglingId === item.id" @change="toggleShowMenu(item)"></v-switch>
          <span class="ml-1">{{ item.cgm_show_menu ? "Shown" : "Hidden" }}</span>
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" v-if="authorize_edit && company_id == 1 && role == 'ADMIN'">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)" v-if="authorize_del && company_id == 1 && role == 'ADMIN'">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
  </v-card>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
export default {
  name: "group-menu",
  data: () => ({
    company_id: localStorage.getItem(server.COMPANYID),
    role: localStorage.getItem(server.ROLE),
    dialog: false,
    search: "",
    dialogDelete: false,
    dialogEdit: false,
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      { text: "Name", value: "cgm_name" },
      { text: "Icon", value: "cgm_icon" },
      { text: "Direct Route", value: "cgm_route" },
      { text: "Sort Order", value: "cgm_sort_order" },
      { text: "Show in menu", value: "cgm_show_menu", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      cgm_name: "",
      cgm_icon: "",
      cgm_route: "",
      cgm_sort_order: 0,
      cgm_show_menu: true,
      company_id: localStorage.getItem(server.COMPANYID),
      user_create: 0,
      user_update: 0,
    },
    editedItem2: {
      cgm_name: "",
      cgm_icon: "",
      cgm_route: "",
      cgm_sort_order: 0,
      company_id: localStorage.getItem(server.COMPANYID),
      user_update: 0,
    },
    edit_item_id: 0,
    togglingId: null,
    defaultItem: {
      cgm_name: "",
      cgm_icon: "",
      cgm_route: "",
      cgm_sort_order: 0,
      cgm_show_menu: true,
      company_id: localStorage.getItem(server.COMPANYID),
      user_create: 0,
      user_update: 0,
    },
    fullPage: true,
    authorize_view: false,
    authorize_add: false,
    authorize_edit: false,
    authorize_del: false,
    authorize_id: 0,
  }),
  components: {
    SuccessDialog,
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Group" : "Edit Group";
    },
  },

  async mounted() {
    await api.checkVersion();
    // ----------------- Check Authorize ---------------------------
    const userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    // const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async created() {
    await this.initialize();
  },

  methods: {
    async initialize() {
      //   alert("initialize");
      // const res_get = await api.getGroupMenu();
      // this.desserts = res_get.data;

      var res_get;

      // if (localStorage.getItem(server.ROLE) == "ADMIN") {
      //   res_get = await api.getGroupMenu();
      //   this.desserts = res_get.data;
      // } else {
      res_get = await api.getGroupMenu_By_CompanyID(
        localStorage.getItem(server.COMPANYID),
      );
      // ⭐ ใหม่: เรียงตาม Sort Order ก่อน ถ้าเท่ากันให้เรียงตามชื่อ (ก-ฮ / A-Z)
      this.desserts = [...res_get.data].sort((a, b) => {
        const orderDiff =
          (a.cgm_sort_order || 0) - (b.cgm_sort_order || 0);
        if (orderDiff !== 0) return orderDiff;
        return (a.cgm_name || "").localeCompare(b.cgm_name || "", "th");
      });
      // }

      // this.$showLoader();
      this.$hideLoader();

      //   console.log("initialize desserts: " + JSON.stringify(res_get.data));
    },

    async toggleShowMenu(item) {
      const previousValue = !item.cgm_show_menu;
      this.togglingId = item.id;
      this.$showLoader();

      try {
        const res_toggle = await api.updateGroupMenu(item.id, {
          cgm_show_menu: item.cgm_show_menu,
          user_update: localStorage.getItem(server.USER_ID),
        });

        if (res_toggle.status !== 200) {
          throw new Error("update failed");
        }

        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Update Show in menu success",
          "text-h5 green--text text-center",
        );
      } catch (error) {
        console.error("toggleShowMenu error:", error);
        item.cgm_show_menu = previousValue;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Update Show in menu Failed",
          "text-h5 red--text text-center",
        );
      } finally {
        this.$hideLoader();
        this.togglingId = null;
      }
    },

    editItem(item) {
      this.edit_item_id = item.id;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.edit_item_id = item.id;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      const res_del = await api.deleteGroupMenu(this.edit_item_id);
      if (res_del.status == 200) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Delete data success",
          "text-h5 green--text text-center",
        );
        this.initialize();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Delete data Failed",
          "text-h5 red--text text-center",
        );
      }
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedItem.cgm_name == "" || this.editedItem.cgm_name == null) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Input Group Menu Name",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.editedIndex > -1) {
        this.editedItem2.user_update = localStorage.getItem(server.USER_ID);
        this.editedItem2.cgm_name = this.editedItem.cgm_name;
        this.editedItem2.cgm_icon = this.editedItem.cgm_icon;
        this.editedItem2.cgm_route = this.editedItem.cgm_route;
        this.editedItem2.cgm_sort_order = this.editedItem.cgm_sort_order;
        this.editedItem2.cgm_show_menu = this.editedItem.cgm_show_menu;
        const res_edit = await api.updateGroupMenu(
          this.edit_item_id,
          this.editedItem2,
        );
        if (res_edit.status == 200) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "Edit data success",
            "text-h5 green--text text-center",
          );
          this.initialize();
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Edit data Failed",
            "text-h5 red--text text-center",
          );
        }
      } else {
        // alert("create");
        this.editedItem.user_create = localStorage.getItem(server.USER_ID);
        const res_add = await api.createGroupMenu(this.editedItem);
        if (res_add.status == 200) {
          // ⭐ ใหม่: ถ้ากรอก Direct Route (กลุ่มนี้เป็น leaf ไม่มี Sub Menu)
          // ให้ auto สร้าง tbl_config_menu_detail + สิทธิ์ให้ทุก role ทันที
          // ป้องกันปัญหาแบบ Calendar ที่สร้าง Group Menu แล้วไม่โผล่ในเมนู/Access Control
          // เพราะไม่มีแถวสิทธิ์ผูกอยู่เลย
          if (
            this.editedItem.cgm_route &&
            this.editedItem.cgm_route.trim() != ""
          ) {
            try {
              const routeName = this.editedItem.cgm_route.replace(/^\/+/, "");

              const res_add_detail = await api.createMenuDetail({
                cmd_name: this.editedItem.cgm_name,
                cmd_route: routeName,
                group_menu_id: res_add.data.id,
                cmd_sort_order: this.editedItem.cgm_sort_order || 0,
                company_id: localStorage.getItem(server.COMPANYID),
                user_create: localStorage.getItem(server.USER_ID),
                user_update: localStorage.getItem(server.USER_ID),
              });

              const res_all_sgm = await api.getSettingGroupMenu();
              for (let i = 0; i < res_all_sgm.data.length; i++) {
                const newSettingDetail = {
                  setting_group_menu_id: res_all_sgm.data[i].id,
                  group_menu_id: res_add.data.id,
                  menu_detail_id: res_add_detail.data.id,
                  company_id: localStorage.getItem(server.COMPANYID),
                  smd_view: 0,
                  smd_add: 0,
                  smd_edit: 0,
                  smd_del: 0,
                  user_create: localStorage.getItem(server.USER_ID),
                  user_update: localStorage.getItem(server.USER_ID),
                };
                await api.createSettingMenuDetail(newSettingDetail);
              }
            } catch (errorAutoDetail) {
              console.error(
                "Auto create menu detail/permission for leaf group failed:",
                errorAutoDetail,
              );
              // ไม่ block การสร้าง group menu หลัก แค่แจ้งเตือนว่าต้องไปสร้าง Sub Menu เอง
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Warning",
                "สร้าง Group Menu สำเร็จ แต่สร้างสิทธิ์อัตโนมัติไม่สำเร็จ กรุณาไปสร้าง Sub Menu ให้กลุ่มนี้เองที่หน้า Sub Menu",
                "text-h5 orange--text text-center",
              );
              this.initialize();
              this.close();
              return;
            }
          }

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "Add data success",
            "text-h5 green--text text-center",
          );
          this.initialize();
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Add data Failed",
            "text-h5 red--text text-center",
          );
        }
      }

      this.close();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.switch-small {
  transform: scale(0.75);
  transform-origin: left center;
}
</style>